import React, { useEffect, useState } from "react";
import { History, Boxes, Store, Truck } from "lucide-react";
import { recentAi, KIND_LABEL } from "../../lib/searchApi";

const TIPS = [
  { icon: Boxes, text: "A SKU code or part name — sales trend, stock cover, suppliers, open POs" },
  { icon: Store, text: "A branch code, name or city — sales, stock, transfers, receivables" },
  { icon: Truck, text: "A supplier code or name — lead time, receipts, on-time delivery, payables" },
];

export function RecentSearches({ onSearch }) {
  const [items, setItems] = useState(null);
  useEffect(() => { recentAi().then(d => setItems(d.items)).catch(() => setItems([])); }, []);
  return (
    <div className="space-y-6" data-testid="ai-search-idle">
      <div className="space-y-2">
        <div className="kpi-label text-[10px]">Search for</div>
        {TIPS.map(t => (
          <div key={t.text} className="flex items-center gap-2.5 text-[13px] text-fg/85"><t.icon size={14} className="text-primary shrink-0" />{t.text}</div>
        ))}
      </div>
      <div>
        <div className="kpi-label text-[10px] mb-2 inline-flex items-center gap-1.5"><History size={10} /> Your recent AI searches</div>
        {items === null && <div className="text-[12px] text-muted">Loading…</div>}
        {items?.length === 0 && <div data-testid="ai-search-recent-empty" className="text-[12px] text-muted">No AI searches yet.</div>}
        <div className="space-y-1" data-testid="ai-search-recent">
          {(items || []).map(r => (
            <button key={r.id} type="button" data-testid={`ai-search-recent-${r.id}`} onClick={() => onSearch({ savedId: r.id, q: r.q, kind: r.kind })}
                    className="w-full text-left px-3 py-2 border border-border rounded-sm hover:border-primary/50 hover:bg-surface-2 transition-colors flex items-center gap-3">
              <span className="text-[10px] uppercase tracking-wider text-subtle w-14 shrink-0">{KIND_LABEL[r.kind]}</span>
              <span className="font-mono-tabular text-[12.5px] truncate">{r.code}</span>
              <span className="text-[11px] text-muted truncate">{r.name || r.q}</span>
              {r.turns > 0 && <span className="text-[10px] text-primary shrink-0">+{r.turns} follow-up{r.turns > 1 ? "s" : ""}</span>}
              <span className="ml-auto text-[10.5px] text-subtle shrink-0">{new Date(r.updated_at || r.created_at).toLocaleDateString("en-PH", { month: "short", day: "numeric" })}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
